<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="loadingDetails" />
      <b-tabs lazy>
        <b-tab active title="المعلومات الأساسية">
          <project-main-info
            :projectId="id"
            ref="mainInfo"
            @confirm="onMainInfoConfirmed"
          />
        </b-tab>
        <b-tab :disabled="id === 'new'" title="قطاع المشروع">
          <project-department :projectId="id" @confirm="" />
        </b-tab>
        <b-tab :disabled="id === 'new'" title="أهداف المشروع">
          <project-goals :projectId="id" />
        </b-tab>
        <b-tab :disabled="id === 'new'" title="محافظات تنفيذ المشروع">
          <project-govs :projectId="id" />
        </b-tab>
        <b-tab :disabled="id === 'new'" title="البيانات المالية للمشروع">
          <project-financial-data :projectId="id" />
        </b-tab>
      </b-tabs>
    </div>
  </b-card>
</template>

<script>
import { BCard, BCol, BTab, BTabs } from "bootstrap-vue";
import ProjectMainInfo from "../../components/ProjectMainInfo.vue";
import ProjectGoals from "../../components/ProjectGoals.vue";
import ProjectGovs from "../../components/ProjectGovs.vue";
import ProjectDepartment from "../../components/ProjectDepartment.vue";
import ProjectFinancialData from "../../components/ProjectFinancialData.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { mapActions, mapGetters } from "vuex";
export default {
  props: ["id"],
  components: {
    BCard,
    BCol,
    BTab,
    BTabs,
    ProjectMainInfo,
    ProjectGoals,
    ProjectGovs,
    ProjectDepartment,
    ProjectFinancialData,
    LoadingOverlay,
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    async onMainInfoConfirmed(form) {
      if (this.id !== "new") {
        await this.updateMainInfo({ form, id: this.id });
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تم تعديل معلومات المشروع  بنجاح ",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
      } else {
        await this.addProject(form);
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت إضافة المشروع  بنجاح ",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        this.$router.push({ name: "un-coop-projects" });
      }
    },
    ...mapActions("UNCoop", [
      "fetchProjectDetails",
      "updateMainInfo",
      "addProject",
    ]),
  },
  computed: {
    ...mapGetters("UNCoop", ["details", "loadingDetails"]),
  },
  async mounted() {
    if (this.id !== "new") {
      await this.fetchProjectDetails(this.id);
      const initObj = { ...this.details };
      initObj.u_n_agent_id = this.details.UNAgent.id;
      delete initObj["UNAgent"];
      this.$refs.mainInfo.init(initObj);
    }
  },
};
</script>
